//dependencias
import React, { Component } from 'react';

//componentes
import MostrarTrabajos from './evaluacionesTotales'

class Index extends Component {

    render(){
        return(
            <div>
                <MostrarTrabajos />
            </div>
        );
    }

}
export default Index;